import { render } from "./Next.vue?vue&type=template&id=c62bb41c"
import script from "./Next.vue?vue&type=script&lang=js"
export * from "./Next.vue?vue&type=script&lang=js"
script.render = render

export default script